import { DepotActions, DepotActionTypes } from '../actions';

export interface DepotState {
  selectedDepotUnloadActionIds: number[];
}

const initState: DepotState = {
  selectedDepotUnloadActionIds: []
};

export function depotReducer(state = initState, action: DepotActions): DepotState {
  switch (action.type) {
    case DepotActionTypes.INIT_UNLOAD_AT_DEPOT: {
      return {
        ...state,
        selectedDepotUnloadActionIds: action.payload.actionIds
      };
    }

    case DepotActionTypes.CLEAR_DEPOT_UNLOAD_ACTION_IDS: {
      return {
        ...state,
        selectedDepotUnloadActionIds: []
      };
    }

    default:
      return state;
  }
}
